import Vue from 'vue'
import Vuex from 'vuex'
// import user from './modules/user' // 暂时不使用user模块，保持空仓库状态
import rechargeIntercept from './modules/rechargeIntercept'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // user,
    rechargeIntercept
  },
  state: {
    // 空仓库，暂无全局状态
  },
  mutations: {
    // 空仓库，暂无mutations
  },
  actions: {
    // 空仓库，暂无actions
  },
  getters: {
    // 空仓库，暂无getters
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js